import { makeAutoObservable } from 'mobx'
import { PageLayoutStore } from 'shared/layout'

export class AdminStore {
  pageLayoutStore = new PageLayoutStore()
  constructor() {
    makeAutoObservable(this)
  }
}
